<template>
    <div class="portlet light profile-sidebar-portlet">
        <!-- SIDEBAR USERPIC -->
        <div class="profile-userpic">
            <img :src="avatar" class="img-responsive" alt="">
        </div>
        <!-- END SIDEBAR USERPIC -->
        <!-- SIDEBAR USER TITLE -->
        <div class="profile-usertitle">
            <div class="profile-usertitle-uid"># {{ uid }}</div>
            <div class="profile-usertitle-name">{{ name }}</div>
            <div class="profile-usertitle-email">Email: {{ email }}</div>
            <div class="profile-usertitle-source">Source: {{ source }}</div>
        </div>
        <!-- END SIDEBAR USER TITLE -->
        <!-- SIDEBAR MENU -->
        <div class="profile-usermenu">
            <ul class="nav" v-if="showUserMenu">
                <li>
                    <a href="javascript:;" @click.prevent="selectCategory('cards')">
                        <i class="fa fa-credit-card-alt"></i> Cards </a>
                </li>
                <li>
                    <a href="javascript:;" @click.prevent="selectCategory('claims')">
                        <i class="fa fa-link"></i> Links </a>
                </li>
                <li>
                    <a href="javascript:;" @click.prevent="selectCategory('transactions')">
                        <i class="fa fa-exchange"></i> Transactions </a>
                </li>
            </ul>
        </div>
        <!-- END MENU -->
    </div>
</template>
<script>
  /* ============
   * User Profile Component
   * ============
   *
   * @emit
   *   onSectionSelected(selectedSection)
   */
  import TuangoPortlet from '@/app/components/Portlet'

  export default {
    name: 'user-profile',
    props: {
      uid: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      email: {
        type: String,
        required: true
      },
      source: {
        type: String,
        required: true
      },
      avatar: {
        type: String,
        default: ''
      },
      showUserMenu: {
        type: Boolean,
        default: true
      }
    },
    components: {
      TuangoPortlet
    },
    methods: {
      selectCategory (event) {
        this.$emit('onSectionSelected', event)
      },
      highlightSelectedCategory (e) {
        $('.profile-usermenu li').removeClass('active')
        $(e.target).closest('li').addClass('active')
      }
    },
    mounted () {
      $('.profile-usermenu li').on('click', this.highlightSelectedCategory)
    },
    beforeDestroy () {
      $('.profile-usermenu li').off('click', this.highlightSelectedCategory)
    }
  }
</script>

<style lang="scss" scoped>
    .profile-sidebar-portlet {
        padding-top: 5px !important;
    }

    .profile-userpic {
      margin: 20px auto 0;
      max-height: 150px;
      max-width: 150px;
    }

    .profile-usertitle {
        text-align: left;
        padding: 0 15px;
        color: #5a7391;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.6;
    }

    .profile-usertitle-uid {
        font-weight: 600;
        margin-bottom: 5px;
    }
</style>




// WEBPACK FOOTER //
// src/app/components/user/Profile.vue